<template lang="pug">
  .b2b-filter-button
    ods-tag(
      closable='',
      type='secondary',
      @close='closeTagFilter')
        span.b2b-filter-button__value {{ $t(filter.value) }} :
        span.b2b-filter-button__query {{ (filter.componente === 'date' ? (filter.tipo === 'daterange' ? getDateString(filter.query[0]) + ' - ' + getDateString(filter.query[1]): getDateString(filter.query)) : (filter.userValue != undefined ? filter.userValue : filter.query)) }}
</template>

<script>

export default {
  name: 'b2b-filter-button',

  props: {
    filter: {
      required: true,
      type: Object
    }
  },

  methods: {
    closeTagFilter () {
      this.$emit('delete-filter', this.filter)
    },

    getDateString (value) {
      return this.$d(value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
